import React, {memo, useEffect, useState} from "react";
import ScrollArea from "react-scrollbar";
import Loading from "../../components/Loading";
import Card from "../../components/Card";
import {useAuth} from "../../hooks/auth.hook";
import {useRequest} from "../../hooks/request.hook";
import {TextField} from "@material-ui/core";


const Profile = () => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [needRequest, setNeedRequest] = useState(true);
    const {user} = useAuth();
    const {request} = useRequest();

    useEffect(() => {
        if(needRequest && user && user.user_type === 2) {
            setLoading(true);
            request({url: '/api/client/client/full'})
                .then(data => {
                    if(data) setUserData(data);

                    setNeedRequest(false);
                    setLoading(false);
                });
        }
    }, [needRequest, request, user]);

    return loading ?
        <Loading centered={false}/> :
        <div className="registration-for-service__profile profile">
            <ScrollArea
                className="profile__wrap-scroll"
                contentClassName="profile__scroll"
                verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                verticalContainerStyle={{borderRadius: 8, width: 8}}
                horizontal={false}
                smoothScrolling={true}
            >
                {userData &&
                    <Card className="profile__card" title="Персональные данные">
                        <div className="profile__fields">
                            <TextField
                                name="last_name"
                                className="profile__field"
                                label="Фамилия"
                                value={userData.last_name}
                                autoComplete='off'
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                            />
                            <TextField
                                name="first_name"
                                className="profile__field"
                                label="Имя"
                                value={userData.first_name}
                                autoComplete='off'
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                            />
                            <TextField
                                name="second_name"
                                className="profile__field"
                                label="Отчество"
                                value={userData.second_name}
                                autoComplete='off'
                                variant="outlined"
                                size="small"
                                fullWidth
                                disabled
                            />
                        </div>
                    </Card>
                }
            </ScrollArea>
        </div>
};

export default memo(Profile);